/**
 * Flight school model. This class stores additional information about businesses that are also flight schools (e.g.,
 * number of instructors).
 */
export class FlightSchool {
  /**
   * Number of full-time CFIs
   */
  cfiCountFull: number;

  /**
   * Number of part-time instructors
   */
  cfiCountPart: number;

  /**
   * Number of contracted CFIs
   */
  cfiCountContract: number;

  /**
   * Parses flight school
   * @param data {any} Flight school data as returned by API
   * @return {FlightSchool} Parsed flight school
   */
  static parse(data: any): FlightSchool {
    return {
      cfiCountFull: data && (data.instructorFull || data.instructorFull === 0) ? data.instructorFull : null,
      cfiCountPart: data && (data.instructorPart || data.instructorPart === 0) ? data.instructorPart : null,
      cfiCountContract: data && (data.cfiCountContract || data.cfiCountContract === 0) ? data.cfiCountContract : null
    };
  }
}
